import { get } from 'lodash';
import React from 'react';
import DragNDropColumns from 'src/components/DragNDropColumns';
import TextAndEditIcon from 'src/components/DragRowDisplay/TextAndEditIcon';
import WarningIcon from 'src/components/Icon/Warning';
import { Field } from 'src/components/RcForm';
import ModalHoc from 'src/constrains/ModalHOC';
import { generateNewContentPage } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/generator';
import { useI18n } from 'src/hooks/useRouterChange';
import { contentPages } from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
import { EnumModuleType } from 'src/types/common/module';
import ContentPageEditModal from '../ContentPageEditModal/ContentPage';
import css from './css.module.less';
const ContentPages = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    value,
    onChange,
    draggableId,
    onSort,
    onDelete,
    onAdd,
    modalOp,
    hasModal,
    modalFunc,
    // contentOptions,
    validators,
    allValidator,
    moduleType,
    onModalConfirm,
    disabled,
    scContentPages,
    // breakpoint,
  } = props;
  const { setShowModal, setModalTitle, setModalContent } = modalOp;

  const handleItemOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    if (onSort) {
      onSort(value, onChange, oldIndex, newIndex);
    }
  };
  const handleOnItemDelete = (index) => {
    if (onDelete) {
      onDelete(value, onChange, index);
    }
  };
  const handleOnClickAdd = () => {
    if (onAdd) {
      //onAdd(value, onChange);
      showModal({
        data: generateNewContentPage(),
        index: value?.length || 0,
        isNew: true,
      });
    }
  };

  const handleOnAdd = (data) => {
    const { isNew } = data;
    if (isNew) {
      if (onAdd) {
        onAdd(value, onChange, data);
      }
    } else {
      if (onModalConfirm) {
        onModalConfirm(value, onChange, data);
      }
    }

    handleModalCancel();
  };

  const handleModalCancel = () => setShowModal(false);

  const showModal = (props: any) => {
    if (hasModal) {
      setShowModal(true);
      setModalTitle(getI18n('salesChannelContent.index.contentPageSetting'));
      setModalContent(
        <ContentPageEditModal
          validators={validators}
          // contentPageList={contentOptions}
          scContentPages={scContentPages}
          modalRenderer={modalFunc}
          onCancel={handleModalCancel}
          onConfirm={handleOnAdd}
          {...props}
        />,
      );
    }
  };

  const checkIndividualContentPage = (data) => {
    const allValidatorsList = [EnumModuleType.ResponsiveContentCarousel];
    //  const { inUsePages = [] } = contentOptions || {};
    if (allValidatorsList.includes(moduleType)) {
      if (allValidator) {
        const res = allValidator(
          data, //{ contentPages: inUsePages }
        );
        const hasError = get(res, 'hasError');
        return hasError;
      }
    }
    return false;
  };

  const childGenerate = (data, index) => {
    const name = get(data, 'contentPage.name');
    const hasError = checkIndividualContentPage(data);
    return (
      <TextAndEditIcon
        additional={
          hasError ? (
            <div className={css.errorIconContainer}>
              <WarningIcon />
            </div>
          ) : null
        }
        name={name}
        onClick={() => showModal({ data, index, disabled })}
      />
    );
  };

  return (
    <React.Fragment>
      <DragNDropColumns
        disabled={disabled}
        disableAddText={disabled}
        hideAdd={disabled}
        hideTitle
        childGenerate={childGenerate}
        data={value || []}
        droppableId={`salesChannelContentListContentPagesCarousel${draggableId}`}
        onSort={handleItemOnSort}
        // hideAdd={hideAdd}
        onAdd={handleOnClickAdd}
        addText={`+ ${getI18n('general.addContentPage')}`}
        onDelete={handleOnItemDelete}
      />
    </React.Fragment>
  );
};

const ContentPagesWithField = (props) => {
  const { draggableId, moduleType, breakpoint, ...p } = props;
  return (
    <Field name={contentPages}>
      {(props, meta) => (
        <ContentPages
          id={`${get(meta, 'name').join('_')}_${draggableId}`}
          draggableId={draggableId}
          moduleType={moduleType}
          breakpoint={breakpoint}
          {...props}
          {...meta}
          {...p}
        />
      )}
    </Field>
  );
};

export default ModalHoc(ContentPagesWithField, { width: 600 });
